import { Context } from '@z-components/utils/oauth';

export const makeContextHeader = (
  context?: Context
): { 'x-social-context': string } | Record<string, unknown> =>
  context === undefined ? {} : { 'x-social-context': context };
